export const objectToString = (obj: Record<string, unknown>): string => {
  if (obj !== null) {
    return Object.values(obj)
      .filter((it) => it != null)
      .join(' ')
  }
}
